import { render, staticRenderFns } from "./TestimonialMobile.vue?vue&type=template&id=0b07c8d2&scoped=true&"
import script from "./TestimonialMobile.vue?vue&type=script&lang=js&"
export * from "./TestimonialMobile.vue?vue&type=script&lang=js&"
import style0 from "./TestimonialMobile.vue?vue&type=style&index=0&id=0b07c8d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b07c8d2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VRow})
